module.exports = function() {
  return new Worker(__webpack_public_path__ + "efb7dbf556ae056ebff8.worker.js");
};